/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePlayerBlacklistDeletedDto,
  ApiEnvelopePlayerBlacklistEntryDto,
  ApiEnvelopePlayerBlacklistListDto,
  CreatePlayerBlacklistEntryRequest,
  UpdatePlayerBlacklistEntryRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type playerBlacklistAdminListEntriesResponse200 = {
  data: ApiEnvelopePlayerBlacklistListDto
  status: 200
}

export type playerBlacklistAdminListEntriesResponseSuccess = (playerBlacklistAdminListEntriesResponse200) & {
  headers: Headers;
};
;

export type playerBlacklistAdminListEntriesResponse = (playerBlacklistAdminListEntriesResponseSuccess)

export const getPlayerBlacklistAdminListEntriesUrl = () => {




  return `/api/admin/blacklist/entries`
}

export const usePlayerBlacklistAdminListEntriesHook = (): ( options?: RequestInit) => Promise<playerBlacklistAdminListEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getPlayerBlacklistAdminListEntriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type playerBlacklistAdminCreateEntryResponse200 = {
  data: ApiEnvelopePlayerBlacklistEntryDto
  status: 200
}

export type playerBlacklistAdminCreateEntryResponse400 = {
  data: ApiEnvelopePlayerBlacklistEntryDto
  status: 400
}

export type playerBlacklistAdminCreateEntryResponseSuccess = (playerBlacklistAdminCreateEntryResponse200) & {
  headers: Headers;
};
export type playerBlacklistAdminCreateEntryResponseError = (playerBlacklistAdminCreateEntryResponse400) & {
  headers: Headers;
};

export type playerBlacklistAdminCreateEntryResponse = (playerBlacklistAdminCreateEntryResponseSuccess | playerBlacklistAdminCreateEntryResponseError)

export const getPlayerBlacklistAdminCreateEntryUrl = () => {




  return `/api/admin/blacklist/entries`
}

export const usePlayerBlacklistAdminCreateEntryHook = (): (createPlayerBlacklistEntryRequest?: CreatePlayerBlacklistEntryRequest, options?: RequestInit) => Promise<playerBlacklistAdminCreateEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (createPlayerBlacklistEntryRequest?: CreatePlayerBlacklistEntryRequest, options?: RequestInit) => {

        return customFetcher(getPlayerBlacklistAdminCreateEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPlayerBlacklistEntryRequest)
  }
);
      }
  }


export type playerBlacklistAdminUpdateEntryResponse200 = {
  data: ApiEnvelopePlayerBlacklistEntryDto
  status: 200
}

export type playerBlacklistAdminUpdateEntryResponse400 = {
  data: ApiEnvelopePlayerBlacklistEntryDto
  status: 400
}

export type playerBlacklistAdminUpdateEntryResponse404 = {
  data: ApiEnvelopePlayerBlacklistEntryDto
  status: 404
}

export type playerBlacklistAdminUpdateEntryResponseSuccess = (playerBlacklistAdminUpdateEntryResponse200) & {
  headers: Headers;
};
export type playerBlacklistAdminUpdateEntryResponseError = (playerBlacklistAdminUpdateEntryResponse400 | playerBlacklistAdminUpdateEntryResponse404) & {
  headers: Headers;
};

export type playerBlacklistAdminUpdateEntryResponse = (playerBlacklistAdminUpdateEntryResponseSuccess | playerBlacklistAdminUpdateEntryResponseError)

export const getPlayerBlacklistAdminUpdateEntryUrl = (id: string,) => {




  return `/api/admin/blacklist/entries/${id}`
}

export const usePlayerBlacklistAdminUpdateEntryHook = (): (id: string,
    updatePlayerBlacklistEntryRequest?: UpdatePlayerBlacklistEntryRequest, options?: RequestInit) => Promise<playerBlacklistAdminUpdateEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updatePlayerBlacklistEntryRequest?: UpdatePlayerBlacklistEntryRequest, options?: RequestInit) => {

        return customFetcher(getPlayerBlacklistAdminUpdateEntryUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePlayerBlacklistEntryRequest)
  }
);
      }
  }


export type playerBlacklistAdminDeleteEntryResponse200 = {
  data: ApiEnvelopePlayerBlacklistDeletedDto
  status: 200
}

export type playerBlacklistAdminDeleteEntryResponse404 = {
  data: ApiEnvelopePlayerBlacklistDeletedDto
  status: 404
}

export type playerBlacklistAdminDeleteEntryResponseSuccess = (playerBlacklistAdminDeleteEntryResponse200) & {
  headers: Headers;
};
export type playerBlacklistAdminDeleteEntryResponseError = (playerBlacklistAdminDeleteEntryResponse404) & {
  headers: Headers;
};

export type playerBlacklistAdminDeleteEntryResponse = (playerBlacklistAdminDeleteEntryResponseSuccess | playerBlacklistAdminDeleteEntryResponseError)

export const getPlayerBlacklistAdminDeleteEntryUrl = (id: string,) => {




  return `/api/admin/blacklist/entries/${id}`
}

export const usePlayerBlacklistAdminDeleteEntryHook = (): (id: string, options?: RequestInit) => Promise<playerBlacklistAdminDeleteEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getPlayerBlacklistAdminDeleteEntryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


